export enum PRODUCTS_SDK_METHODS {
    GET_PRODUCTS_STATE_KIT = "getProductsStateKit",
}
